import { cn } from '../../lib/utils';

type BadgeVariant = 'success' | 'info' | 'warning' | 'critical' | 'default';

export interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
}

const variantStyles: Record<BadgeVariant, string> = {
  success: 'bg-success-lighter text-success-dark',
  info: 'bg-info-lighter text-info',
  warning: 'bg-warning-lighter text-warning-dark',
  critical: 'bg-critical-lighter text-critical-dark',
  default: 'bg-surface-hovered text-text',
};

export function Badge({ children, variant = 'default', className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-0.5 rounded text-xs font-medium',
        variantStyles[variant],
        className
      )}
    >
      {children}
    </span>
  );
}













